import QueueLink from 'apollo-link-queue';

const link = new QueueLink();

export { link };
